import React, { ReactElement } from "react";
import { Heading } from "web/react/emo/heading";
import { gettext } from "web/script/modules/django-i18n";
import * as styles from "./order-history-details.css";

export function OrderHistoryDetails(): ReactElement {
    return (
        <div className={styles.content}>
            <Heading as="h1" textStyle="hero-s">
                {gettext("order_history.order_details.title")}
            </Heading>

            <section style={{ border: "1px solid black", marginTop: "2rem" }}>
                {"Order History Details is coming soon!"}
            </section>
        </div>
    );
}

export default OrderHistoryDetails;
